import { useStyles } from './styles'
import { CaseIdToFolder } from '@/pages/casePage/types'
export const CaseImage = ({ caseId }: { caseId: number }) => {
  const { classes } = useStyles()
  const differentImageCases = ['steamDeck']
  const imgSrc = differentImageCases.includes(CaseIdToFolder[caseId])
    ? `/assets/lootBoxRelated/differentCaseImages/${caseId}Case.webp`
    : `/assets/lootBoxRelated/boxes/${caseId}Box.webp`

  return (
    <>
      <div className={classes.boxWrapper}>
        <img
          src={imgSrc}
          alt=""
          data-isdifferentpositioning={CaseIdToFolder[caseId]}
          className={classes.img}
          data-tapps={caseId === 17}
        />
      </div>
    </>
  )
}

// const AdditionalImage = ({ caseName }: { caseName: string }) => {
//   const { classes } = useStyles()

//   if (caseName === 'Steam On! Case') {
//     return (
//       <img
//         src="/assets/backgrounds/steamDeck.webp"
//         className={classes.steamDeckImage}
//       />
//     )
//   }
//   return null
// }
